import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-dialog", {
    attrs: {
      title: "等级配置",
      visible: _vm.visible,
      width: "480px",
      "custom-class": "city-level-model"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      }
    }
  }, [_c("el-form", {
    ref: "form",
    attrs: {
      model: _vm.formData,
      rules: _vm.rules,
      inline: true
    }
  }, [_c("el-form-item", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      label: "评级开启城市",
      prop: "cityIds"
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "325px"
    },
    attrs: {
      size: "mini",
      multiple: "",
      clearable: "",
      placeholder: "请选择"
    },
    model: {
      value: _vm.formData.cityIds,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "cityIds", $$v);
      },
      expression: "formData.cityIds"
    }
  }, _vm._l(_vm.cities, function (item) {
    return _c("el-option", {
      key: item.token,
      attrs: {
        label: item.name,
        value: item.token
      }
    });
  }), 1)], 1), _c("div", {
    staticClass: "tips"
  }, [_vm._v(" 启用后，系统将根据不同分段实施相应的奖惩措施。 ")])], 1), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      size: "small"
    },
    on: {
      click: function click($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v("取 消")]), _c("el-button", {
    attrs: {
      type: "primary",
      size: "small",
      loading: _vm.loading
    },
    on: {
      click: _vm.commit
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };